import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const planDetails = async (lang, serviceId) => {
  try {
    // Remove "SERVICE#" prefix if present
    const cleanServiceId = serviceId?.replace(/^SERVICE#/, '');

    const token = sessionStorage.getItem('token');
    const API_URL = `${apiUrl}/api/v1/planUsageDetails/getPlanData/${cleanServiceId}?lang=${lang}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching plan details:", error);
    throw error;
  }
};

export default { planDetails };
